import { render, staticRenderFns } from "./trace-variables.page.vue?vue&type=template&id=13a3a1e8&scoped=true&"
import script from "./trace-variables.page.vue?vue&type=script&lang=js&"
export * from "./trace-variables.page.vue?vue&type=script&lang=js&"
import style0 from "./trace-variables.page.vue?vue&type=style&index=0&id=13a3a1e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a3a1e8",
  null
  
)

export default component.exports